// A buy-bonus purchase row (Purchases tab). Pure render — values pre-derived in
// the bets mapper. Columns: Date(date/time) | Type | Amount | Status.
const PurchaseCard = ({ data }) => (
  <div className="standard-normal-bet-card-outer-container">
    <div className="standard-normal-bet-card-inner-container">
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-date">{data?.date}</div>
        <div className="standard-normal-bet-card-element-time">{data?.time}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-subType">{data?.subTypeText}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-stake">{data?.stake}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-subType">{data?.statusText}</div>
      </div>
    </div>
  </div>
)

export default PurchaseCard
